import { ProDetailList } from '@bedrock/eed-react';
import {
  FormCard,
  FormItemAdvanceFunding,
  FormItemCurrency,
  FormItemFinanceAttachmentFile,
  FormItemFinanceAttachmentType,
  FormItemFinanceDetailList,
  FormItemFiscalVBankCash,
  FormItemGameBusinessRevenue,
  FormItemGroupBusinessRevenue,
  FormItemIncomeNumber,
  FormItemNetEaseGameBusinessRevenue,
  FormItemPaidUpCapitalNumber,
  FormItemProfitNumber,
  FormItemTotalAssetsNumber,
  FormItemYearPicker,
} from '@purchase/supplier';
import { Tag, Popover } from '@bedrock/components';
import { CaretRight } from '@bedrock/icons-react';
import React from 'react';
import './index.less';

const FinancialInfo = (props: { formDetail: any }) => {
  const { formDetail } = props;
  const hasFinanceInfos = !!formDetail?.vendorFinanceInfo?.financeInfos?.length;
  const financeAbsenceReason =
    formDetail?.vendorFinanceInfo?.financeAbsenceReason;

  const getAbsenceTag = () => {
    if (hasFinanceInfos) return null;
    // 有缺失原因
    if (financeAbsenceReason) {
      return (
        <Popover
          title="缺失原因"
          content={financeAbsenceReason}
          placement="bottom"
        >
          <Tag
            size="xSmall"
            color="orange"
            text={
              <span>
                财务状况缺失 <CaretRight />
              </span>
            }
          />
        </Popover>
      );
    }
    // 无缺失原因
    return <Tag size="xSmall" color="orange" text="财务状况缺失" />;
  };

  return (
    <FormCard
      title="财务状况"
      className={'mpc-supplier-new-detail-financial-info'}
      leftSlot={getAbsenceTag()}
    >
      {/* 财务指标卡片网格 */}
      <div className="mpc-supplier-new-detail-financial-info-descriptions">
        <div className="mpc-supplier-new-detail-financial-info-descriptions-item">
          <FormItemAdvanceFunding
            label="可垫资量级"
            name={['vendorFinanceInfo', 'advanceFunding']}
          />
        </div>
        <div className="mpc-supplier-new-detail-financial-info-descriptions-item">
          <FormItemFiscalVBankCash
            label="最近一年度末现金及银行存款"
            name={['vendorFinanceInfo', 'fiscalVbankCash']}
            fieldProps={{
              highlight: true,
              showUnitIndicator: true,
              style: { color: 'var(--status-warning-1)' },
            }}
          />
        </div>
        <div className="mpc-supplier-new-detail-financial-info-descriptions-item">
          <FormItemGroupBusinessRevenue
            label="网易集团业务收入占比"
            name={['vendorFinanceInfo', 'groupBusinessRevenue']}
          />
        </div>
        <div className="mpc-supplier-new-detail-financial-info-descriptions-item">
          <FormItemGameBusinessRevenue
            label="游戏业务收入占比"
            name={['vendorFinanceInfo', 'gameBusinessRevenue']}
          />
        </div>
        <div className="mpc-supplier-new-detail-financial-info-descriptions-item">
          <FormItemNetEaseGameBusinessRevenue
            label="网易游戏业务收入占比"
            name={['vendorFinanceInfo', 'netEaseGameBusinessRevenue']}
          />
        </div>
      </div>

      {!financeAbsenceReason && (
        <FormItemFinanceDetailList
          name={['vendorFinanceInfo', 'financeInfos']}
          reminderDisabled
          fieldProps={{ scroll: { x: 1120 } }}
        >
          <ProDetailList.Item
            label="#"
            name="#"
            meta={{ columnProps: { width: 50, fixed: true } }}
          >
            {(value, record, index) => {
              return index + 1;
            }}
          </ProDetailList.Item>
          <FormItemYearPicker
            name="year"
            label="年份"
            meta={{
              columnProps: { width: 80, className: 'font-bold', fixed: true },
            }}
          />
          <FormItemCurrency
            name="currency"
            label="币种"
            meta={{ columnProps: { width: 100 } }}
          />
          <FormItemIncomeNumber name="income" label="营业收入 (万)" />
          <FormItemProfitNumber name="profit" label="利润总额 (万)" />
          <FormItemPaidUpCapitalNumber
            name="paidUpCapital"
            label="实缴资本 (万)"
          />
          <FormItemTotalAssetsNumber name="totalAssets" label="总资产 (万)" />
          <FormItemFinanceAttachmentType
            name="financeAttachmentFileType"
            label="上传类型"
            meta={{ columnProps: { width: 160 } }}
          />
          <FormItemFinanceAttachmentFile
            name="attachmentFile"
            label="附件"
            meta={{ columnProps: { width: 240 } }}
          />
        </FormItemFinanceDetailList>
      )}
    </FormCard>
  );
};

export default FinancialInfo;
